import { render, staticRenderFns } from "./OrderPreference.vue?vue&type=template&id=b88856da&"
import script from "./OrderPreference.vue?vue&type=script&lang=js&"
export * from "./OrderPreference.vue?vue&type=script&lang=js&"
import style0 from "./OrderPreference.vue?vue&type=style&index=0&id=b88856da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports